import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  DOCUMENT_DISPLAY_MODE_DESKTOP_WINDOW,
  DOCUMENT_DISPLAY_MODE_INPAGE
} from '../helpers/utils';
import RequestStepper from './RequestStepper';
import DesktopDocumentsList from './DesktopDocumentsList';
import MobileDocumentsList from './MobileDocumentsList';
import withDocumentRootLogic from '../helpers/withDocumentRootLogic';
import withDocumentsList from './withDocumentsList';

const RequestedDocuments = props => {
  return (
    <Fragment>
      {props.displayMode === DOCUMENT_DISPLAY_MODE_INPAGE ? (
        <RequestStepper {...props} />
      ) : props.displayMode === DOCUMENT_DISPLAY_MODE_DESKTOP_WINDOW ? (
        <DesktopDocumentsList {...props} />
      ) : (
        <MobileDocumentsList {...props} />
      )}
    </Fragment>
  );
};

RequestedDocuments.propTypes = {
  displayMode: PropTypes.string
};

export default withDocumentRootLogic(withDocumentsList(RequestedDocuments));
